import OrderPaymentSelectors from './OrderPayment/OrderPaymentSelectors';
import DonationSelectors from './Donation/DonationSelectors';

export default {
	orders: OrderPaymentSelectors,
	donations: DonationSelectors,
};
